if (!customElements.get('login-component')) {
  customElements.define(
    'login-component',
    class LoginComponent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.showButton = this.querySelector('[data-show-reset]');
        this.hideButton = this.querySelector('[data-hide-reset]');
        this.recover = this.querySelector('[data-recover-password]');
        this.login = this.querySelector('[data-login-form]');
        this.success = this.querySelector('[data-recover-success]');
        this.successText = this.querySelector('[data-recover-success-text]');

        this.init();
      }

      init() {
        if (window.location.hash == '#recover') {
          this.showRecoverPasswordForm();
        } else {
          this.hideRecoverPasswordForm();
        }

        if (this.success) {
          this.successText.classList.remove('is-hidden');
        }

        this.showButton?.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            this.showRecoverPasswordForm();
          },
          false
        );
        this.hideButton?.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            this.hideRecoverPasswordForm();
          },
          false
        );
      }

      showRecoverPasswordForm() {
        this.recover.classList.remove('is-hidden');
        this.login.classList.add('is-hidden');
        window.location.hash = '#recover';
        return false;
      }

      hideRecoverPasswordForm() {
        this.login.classList.remove('is-hidden');
        this.recover.classList.add('is-hidden');
        window.location.hash = '';
        return false;
      }
    }
  );
}
